import React from 'react';

interface ShieldIconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const ShieldIcon: React.FC<ShieldIconProps> = ({
  fillColor = '#AAAAAA',
  ...rest
}) => {
  return (
    <svg
      {...rest}
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.51667 19.8434C7.00923 20.1747 7.39659 20.4054 7.62732 20.5295C7.86193 20.6558 8.13807 20.6558 8.37268 20.5295C8.60341 20.4054 8.99077 20.1747 9.48333 19.8434C10.3001 19.2941 11.1167 18.657 11.8821 17.9364C14.1285 15.8212 15.5 13.4231 15.5 10.7604V3.58663C15.5 3.17516 15.2398 2.81649 14.8688 2.71669L8.20211 0.923258C8.06941 0.88756 7.93059 0.88756 7.79789 0.923258L1.13122 2.71669C0.760248 2.81649 0.5 3.17516 0.5 3.58663V10.7604C0.5 13.4231 1.87147 15.8212 4.11791 17.9364C4.88328 18.657 5.6999 19.2941 6.51667 19.8434ZM10.7846 16.5867C10.0916 17.2391 9.34574 17.821 8.6 18.3226C8.38573 18.4667 8.1845 18.5953 8 18.7077C7.8155 18.5953 7.61427 18.4667 7.4 18.3226C6.65426 17.821 5.90838 17.2391 5.21542 16.5867C3.2952 14.7787 2.16667 12.8054 2.16667 10.7604V4.28676L8 2.71751L13.8333 4.28676V10.7604C13.8333 12.8054 12.7048 14.7787 10.7846 16.5867Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ShieldIcon;
